import { Button } from "@/components/ui/button";
import { proxiedImage } from "@/lib/api";

const DUBSADO_FORM_URL = "https://portal.dubsado.com/public/form/view/6496389c622129003a6f8e39";
const SPONSOR_TIERS_IMAGE = "https://customer-assets.emergentagent.com/job_pitch-and-vote/artifacts/1e2p83bw_Sponsor%20picture.png";
const EVENTBRITE_TICKETS_URL = "https://www.eventbrite.com/e/1988836397202?aff=oddtdtcreator";

export default function SponsorshipSection({ sectionId }) {
  return (
    <section
      id={sectionId}
      data-testid="sponsorship-section"
      className="bg-white py-20 sm:py-24 border-t border-b border-emerald-100"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="max-w-2xl mb-10">
          <div className="text-[11px] uppercase tracking-[0.3em] text-rose-600 font-[Outfit] font-bold">
            Become a Sponsor
          </div>
          <h2 className="font-[Cormorant_Garamond] text-4xl sm:text-5xl text-emerald-950 mt-3 leading-tight">
            Sponsor the businesses powering our economy
          </h2>
          <p className="text-slate-700 font-[Outfit] mt-4 leading-relaxed">
            Small businesses are the engine of community wealth. Every sponsorship dollar
            fuels entrepreneurs at every stage — <b>starting, sustaining, and growing</b>.
            The Business Showers cohort spans medical offices, engineers, coaches, makers,
            consultants, service providers and more. Stand with the people building what
            our neighborhoods, families and economy need next.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-10 items-start">
          <div className="lg:col-span-2 bg-emerald-50 rounded-2xl border border-emerald-200 overflow-hidden">
            <img
              src={proxiedImage(SPONSOR_TIERS_IMAGE)}
              alt="Sponsorship levels: Silver $1,500 · Gold $3,000 · Platinum $5,000 · Diamond $10,000 · Legacy $25,000"
              loading="lazy"
              className="w-full h-auto block"
              data-testid="sponsor-tiers-image"
            />
          </div>

          <div className="space-y-6">
            <div className="bg-emerald-950 text-white rounded-2xl p-6">
              <div className="text-[11px] uppercase tracking-[0.25em] text-amber-300 font-[Outfit] font-bold">
                Tiers · Silver → Legacy
              </div>
              <div className="font-[Cormorant_Garamond] text-2xl mt-2 leading-tight">
                Sponsorship from $1,500 to $25,000
              </div>
              <p className="text-emerald-100 font-[Outfit] text-sm mt-3 leading-relaxed">
                Apply through our official sponsorship application — includes contact info, logo upload, and tier selection.
              </p>
              <Button
                asChild
                data-testid="sponsorship-apply-cta"
                className="mt-5 rounded-full bg-amber-300 hover:bg-amber-400 text-emerald-950 font-[Outfit] font-semibold w-full h-11"
              >
                <a href={DUBSADO_FORM_URL} target="_blank" rel="noreferrer">
                  Open Sponsorship Application →
                </a>
              </Button>
            </div>

            <div className="bg-rose-50 border border-rose-200 rounded-2xl p-6">
              <div className="text-[11px] uppercase tracking-[0.25em] text-rose-600 font-[Outfit] font-bold">
                New · July 18 Only
              </div>
              <div className="font-[Cormorant_Garamond] text-2xl mt-2 leading-tight text-emerald-950">
                Business Showers Event Table
              </div>
              <div className="font-[Outfit] text-rose-700 font-bold text-3xl mt-2">$550</div>
              <ul className="font-[Outfit] text-sm text-slate-700 mt-3 space-y-1.5 leading-relaxed">
                <li>• 8 reserved seats at the celebration</li>
                <li>• Table tent card featuring your business</li>
                <li>• Recognition during the event</li>
                <li className="text-slate-500 text-xs">Note: This is not a marketing table.</li>
              </ul>
              <Button
                asChild
                data-testid="table-sponsor-cta"
                className="mt-5 rounded-full bg-rose-500 hover:bg-rose-600 text-white font-[Outfit] font-semibold w-full h-11"
              >
                <a href={EVENTBRITE_TICKETS_URL} target="_blank" rel="noreferrer">
                  Reserve a Table on Eventbrite →
                </a>
              </Button>
            </div>
          </div>
        </div>

        <p className="text-xs text-slate-500 font-[Outfit] mt-8 max-w-3xl">
          Questions about sponsorship? Contact Donja Williams at
          {" "}<a href="mailto:info@itsthefreedominme.com" className="text-emerald-800 underline">info@itsthefreedominme.com</a>{" "}
          or 980-292-1622.
        </p>
      </div>
    </section>
  );
}
